export var createIfNotExistContainerElement = function () {
    var el = document.createElement('div');
    el.id = 'alwayson_chatbot';
    document.body.insertAdjacentElement('beforeend', el);
};
